import { useQuery } from "@tanstack/react-query";
import type { Generation } from "@/lib/db/schema";
import { useSession } from "@/lib/auth/client";

// Extended generation type that includes the vehicle image URL from the joined upload and wheel data
export interface GenerationWithVehicle extends Generation {
  vehicleImageUrl: string | null;
  rim?: { id: string; name: string; imageUrl: string } | null;
  userRim?: { id: string; name: string; imageUrl: string; brand?: string; sku?: string } | null;
}

interface GenerationsResponse {
  generations: GenerationWithVehicle[];
}

export function useGenerations() {
  const { data: session } = useSession();
  const isAuthenticated = !!session?.user;

  return useQuery<GenerationsResponse>({
    queryKey: ["generations"],
    queryFn: async () => {
      const response = await fetch("/api/generations");
      if (!response.ok) {
        throw new Error("Failed to fetch generations");
      }
      return response.json();
    },
    enabled: isAuthenticated, // Only fetch when user is authenticated
    refetchOnWindowFocus: true,
    // History list should not poll; completion-driven updates come from `useGeneration(id)`
    // (and explicit invalidations after create/unlock).
    staleTime: 30_000,
  });
}
